import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WorkshopModel, GenerateLabelsRequest, WorkshopQuantityRequest, GenerateMultipleLabelsRequest } from '../../models/workshop-model/workshop-model';

@Injectable({
  providedIn: 'root'
})
export class WorkshopsService {

  private apiUrl = environment.apiEndpoint + '/Workshop';

  constructor(private http: HttpClient) { }

  getWorkshops(): Observable<WorkshopModel[]> {
    return this.http.get<WorkshopModel[]>(`${this.apiUrl}`);
  }

  // Alias for backward compatibility
  getAllWorkshops(): Observable<WorkshopModel[]> {
    return this.getWorkshops();
  }

  getWorkshop(id: number): Observable<WorkshopModel> {
    return this.http.get<WorkshopModel>(`${this.apiUrl}/${id}`);
  }

  createWorkshop(workshop: Partial<WorkshopModel>): Observable<WorkshopModel> {
    return this.http.post<WorkshopModel>(`${this.apiUrl}`, workshop);
  }

  updateWorkshop(id: number, workshop: WorkshopModel): Observable<WorkshopModel> {
    return this.http.put<WorkshopModel>(`${this.apiUrl}/${id}`, workshop);
  }

  deleteWorkshop(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  downloadLabels(workshopId: number, request: GenerateLabelsRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/${workshopId}/labels`, request, {
      responseType: 'blob'
    });
  }

  downloadMultipleLabels(request: GenerateMultipleLabelsRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/labels/multiple`, request, {
      responseType: 'blob'
    });
  }
}